import React from "react";
import "./Footer.css";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaChevronDown,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import gpay from "../Images/paypal1.png";
import phonepe from "../Images/google pay 1.png";
import paypal from "../Images/upi1.png";
import visa from "../Images/mastercard.png";
import rezorpay from "../Images/rezorpay.png";

import { useCountry } from "./CountryContext";

function Footer() {
  // =========================
  // COUNTRY CONTEXT
  // =========================
  const {
    country,
    setCountry,
    countries,
    currentCountry,
  } = useCountry();

  // =========================
  // NAVIGATION
  // =========================
  const navigate = useNavigate();

  return (
    <footer className="footer">

      {/* =========================
          FOOTER CONTAINER
      ========================== */}
      <div className="footer-container">

        {/* Column 1 */}
        <div className="footer-col">

          <h3 className="mobile-brand1">
            African Shopping Store
          </h3>

          <p>
            African Shopping Store brings you premium African fashion,
            accessories, and unique designs inspired by rich African
            culture and heritage. We combine traditional elegance with
            modern style to offer quality collections for every occasion.
          </p>

        </div>


        {/* Column 2 */}
        <div className="footer-col">

          <h4>Navigate</h4>

          <ul>
            <li>Shipping & Returns</li>
            <li>RSS Syndication</li>
            <li>Blog</li>
            <li>Sitemap</li>
          </ul>

        </div>


        {/* Column 3 */}
        <div className="footer-col">

          <h4>Categories</h4>

          <ul>

            {/* MENS */}
            <li
              onClick={() => navigate("/mens")}
              style={{ cursor: "pointer" }}
            >
              Mens
            </li>


            {/* WOMENS */}
            <li
              onClick={() => navigate("/womens")}
              style={{ cursor: "pointer" }}
            >
              Womens
            </li>


            {/* ACCESSORIES */}
            <li
              onClick={() => navigate("/jewellery")}
              style={{ cursor: "pointer" }}
            >
              Accessories
            </li>


            {/* PARTY WEAR */}
            <li
              onClick={() => navigate("/party-wear")}
              style={{ cursor: "pointer" }}
            >
              Party Wear
            </li>

          </ul>

        </div>


        {/* Column 4 */}
        <div className="footer-col">

          <h4>Information</h4>

          <p>
            <FaMapMarkerAlt />
            &nbsp; 43 Victoria St, Wolverhampton WV1 3PJ,
            United Kingdom
          </p>

          <p>
            <FaPhoneAlt />
            &nbsp; (+44) 7482041518
          </p>

          <p>
            <FaEnvelope />
            &nbsp; testing@gmail.com
          </p>

        </div>

      </div>


      {/* =========================
          EXTRA BAR
      ========================== */}
      <div className="footer-extra">

        {/* COUNTRY SELECTOR */}
        <div className="country-selector-wrapper">

          <div className="country-label">

            <span className="country-globe">
              🌍
            </span>

            <span>
              Ship to
            </span>

          </div>


          <div className="country-select">

            <span className="selected-flag">
              {currentCountry.flag}
            </span>


            <select
              value={country}
              onChange={(e) => {
                setCountry(e.target.value);
              }}
            >

              {Object.entries(countries).map(
                ([key, item]) => (

                  <option
                    key={key}
                    value={key}
                  >
                    {item.name} ({item.currency})
                  </option>

                )
              )}

            </select>


            <FaChevronDown className="country-arrow" />

          </div>


          {/* CURRENT CURRENCY */}
          <div className="currency-display">

            <span>
              Currency:
            </span>

            <strong>
              {currentCountry.symbol}{" "}
              {currentCountry.currency}
            </strong>

          </div>

        </div>


        {/* =========================
            SOCIAL ICONS
        ========================== */}
        <div className="social-icons">

          <a
            href="https://www.instagram.com/african_fashion_shop_wolves?igsh=aTJldmpsdzMzcGN0"
            target="_blank"
            rel="noreferrer"
          >
            <i
              className="fa-brands fa-instagram"
              data-aos="fade-down"
              data-aos-duration="1500"
            ></i>
          </a>


          <a
            href="https://www.facebook.com/yourusername"
            target="_blank"
            rel="noreferrer"
          >
            <i
              className="fa-brands fa-facebook-f"
              data-aos="fade-down"
              data-aos-duration="1300"
            ></i>
          </a>


          <a
            href="https://wa.me/919876543210"
            target="_blank"
            rel="noreferrer"
          >
            <i
              className="fa-brands fa-whatsapp"
              data-aos="fade-down"
              data-aos-duration="1100"
            ></i>
          </a>


          <a
            href="https://twitter.com/yourusername"
            target="_blank"
            rel="noreferrer"
          >
            <i
              className="fa-brands fa-x-twitter"
              data-aos="fade-down"
              data-aos-duration="900"
            ></i>
          </a>


          <a
            href="https://www.youtube.com/@yourchannel"
            target="_blank"
            rel="noreferrer"
          >
            <i
              className="fa-brands fa-youtube"
              data-aos="fade-down"
              data-aos-duration="800"
            ></i>
          </a>

        </div>

      </div>


      {/* =========================
          PAYMENT METHODS
      ========================== */}
      <div className="payment-row">

        <img
          src={gpay}
          alt="Google Pay"
          data-aos="fade-up"
          data-aos-duration="2800"
        />

        <img
          src={phonepe}
          alt="PhonePe"
          data-aos="fade-up"
          data-aos-duration="2500"
        />

        <img
          src={paypal}
          alt="PayPal"
          data-aos="fade-up"
          data-aos-duration="2200"
        />

        <img
          src={visa}
          alt="Visa"
          data-aos="fade-up"
          data-aos-duration="2000"
        />

        <img
          src={rezorpay}
          alt="Razorpay"
          data-aos="fade-up"
          data-aos-duration="1800"
        />

      </div>


      {/* =========================
          FOOTER BOTTOM
      ========================== */}
      <div className="footer-bottom">

        <p>
          © 2026 African Ecommerce.
          All Rights Reserved.
        </p>

        <p className="footer-region-text">

          {currentCountry.flag}

          {" "}Shopping from{" "}

          <strong>
            {currentCountry.name}
          </strong>

          {" • "}

          <strong>
            {currentCountry.currency}
          </strong>

        </p>

      </div>

    </footer>
  );
}

export default Footer;

